/**
 * Possible result status values returned by the API.
 */
export const ResultStatus = Object.freeze({
  SUCCESS: 0,
  WARNING: 1,
  NOT_FOUND: -3,
  UNAUTHORIZED: -2,
  ERROR: -1,
});

/**
 * Generic shape shared by most service responses.
 */
export class ServiceResponse {
  constructor(data = {}) {
    this.errorCode = typeof data.errorCode === 'number' ? data.errorCode : 0;
    this.message = data.message ?? '';
    this.resultStatus = typeof data.resultStatus === 'number' ? data.resultStatus : ResultStatus.SUCCESS;
    this.total = typeof data.total === 'number' ? data.total : 0;
    this.extraData = data.extraData ?? null;
    this.exception = data.exception ?? null;
  }
}

/**
 * Service response that wraps a numeric value.
 */
export class NumberServiceResponse extends ServiceResponse {
  constructor(data = {}) {
    super(data);
    this.data = typeof data.data === 'number' ? data.data : null;
  }
}
